import { useSpotlightSearch } from "@circle-react/components/Modals/SpotlightSearch";

import { t } from "@/i18n-js/instance";

import { HeaderIconButton } from "../RightActionBlock/HeaderIconButton";

export interface SearchButtonProps {
  isDisabled?: boolean;
  isPreviewMode?: boolean;
}

export const SearchButton = ({
  isPreviewMode = false,
  isDisabled = false,
}: SearchButtonProps) => {
  const spotlightSearch = useSpotlightSearch();
  const label = t("search_item");

  return (
    <HeaderIconButton
      icon="magnifying-glass"
      ariaLabel={label}
      disabled={isDisabled}
      onClick={() => !isPreviewMode && void spotlightSearch.show()}
      data-testid="header-v4-search-button"
    />
  );
};
